import { Outlet } from "react-router-dom";
import ModuleNavbar from "../ModuleNavbar";
import { Sidebar } from "../Sidebar";

export default function DashboardLayout() {
  return (
    <>
      <ModuleNavbar />

      <div className="app-shell-with-header">
        <Sidebar />

        <>
          <Outlet />
        </>
      </div>
    </>
  );
}